<template>
    <div v-if="!shareIsEmpty" class="vue-share">
      <div @click="$emit('popoverClose')" class="share__popup-close">
          <svg width="12"
               height="12"
               viewBox="0 0 12 12"
               fill="none"
               xmlns="http://www.w3.org/2000/svg">
              <path d="M6.00005 5.36846L0.631575 0L0 0.631574L5.36847 6.00003L6.74523e-05 11.3684L0.631643 12L6.00005 6.63161L11.3684 11.9999L11.9999 11.3683L6.63162 6.00003L12 0.631668L11.3684 9.42307e-05L6.00005 5.36846Z"
                    fill="black"/>
          </svg>
      </div>

      <div class="vue-share__list">
            <div ref="share" :data-services="share.services"></div>

            <span class="vue-share__item" @click="$emit('shareMail')">
                <svg width="40"
                     height="40"
                     viewBox="0 0 40 40"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <rect width="40"
                          height="40"
                          rx="20"
                          fill="#101417"/>
                    <path d="M13.6079 14C13.1231 14 12.922 14.6207 13.3146 14.905L19.7068 19.5332C19.8817 19.6599 20.1183 19.6599 20.2932 19.5332L26.6854 14.905C27.078 14.6207 26.8769 14 26.3921 14H13.6079ZM11.7932 16.3379C11.4626 16.0985 11 16.3347 11 16.7429V25.5C11 25.7761 11.2239 26 11.5 26H28.5C28.7761 26 29 25.7761 29 25.5V16.7429C29 16.3347 28.5374 16.0985 28.2068 16.3379L20.3884 21.9989C20.2766 22.0794 20.1402 22.123 20 22.123C19.8598 22.123 19.7234 22.0794 19.6116 21.9989L11.7932 16.3379Z"
                          fill="white"/>
                </svg>
            </span>
        </div>

        <div :class="['vue-share__copy', {'vue-share__copy_is_copy': linkCopy}]" @click="copyHref">
            <transition name="fade" mode="out-in">
                <div :key="linkCopy">{{ linkCopy ? 'Ссылка скопирована' : 'Скопировать ссылку' }}</div>
            </transition>
        </div>
    </div>
</template>

<script>
    import Utils from '../../helpers/Utils';

    export default {
        props: ['share', 'link'],

        data: () => ({
            yaShare: null,
            linkCopy: false
        }),

        computed: {
            shareIsEmpty() {
                return Object.keys(this.share).length === 0 && this.share.constructor === Object;
            }
        },

        watch: {
          link() {
              this.updateLink();
          }
        },

        methods: {
            initShares() {
                try {
                    // eslint-disable-next-line no-undef
                    this.yaShare = Ya.share2(this.$refs.share, {
                        content: {
                            url        : window.location.href,
                            image      : this.share.image,
                            title      : this.share.title,
                            description: this.share.description
                        },
                        hooks: {
                            onshare: () => {
                                this.updateLink();
                            }
                        }
                    });

                    this.updateLink();

                    return true;
                } catch(err) {
                    console.error(err); // eslint-disable-line

                    return false;
                }
            },

            updateLink() {
                if (!this.yaShare) {
                    return;
                }

                this.yaShare.updateContent({
                    url: window.location.href
                });
            },

            destroyShare() {
                if (this.yaShare.destroy) {
                    this.yaShare.destroy();
                }
            },

            copyHref() {
                Utils.copyToClipboard(window.location.href);
                this.linkCopy = true;
            },

            resetCopy() {
                this.linkCopy = false;
            }
        },

        mounted() {
            this.intervalInit = setInterval(() => {
                if (this.initShares()) {
                    clearInterval(this.intervalInit);
                }
            }, 250);

            setTimeout(() => {
                clearInterval(this.intervalInit);
            }, 1000);
        },

        destroyed() {
            this.destroyShare();
        }
    }
</script>

<style lang="scss">
    @import "./Share";
</style>
